import fetcher from '../fetcher'
import config from '../../config'
import type { IResponseBody } from '../types'

export interface ZriveProgram {
  id: number
  name: string
  longName: string
  url?: string | null
  enableForReferralProgram?: boolean
}

export const getZrivePrograms = async (): Promise<ZriveProgram[]> => {
  const res: IResponseBody<ZriveProgram[]> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/zrive/programs`, { method: 'GET' })
  return res.data ?? []
}
